export default __webpack_public_path__ + "static/media/kelas2.6c985892.png";